export default __webpack_public_path__ + "static/media/benefits_fastrackicon.6add2d02.svg";